<template><SimpleModuleDashboard :module-id="Modules.BCRA" :profile-id="Profiles.PERSONAL" include-php-custom :actions="dashboardActions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Helper from '@/handler/helper'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default {
  components: { SimpleModuleDashboard },
  data: () => ({ Modules, Profiles }),
  computed: {
    isSeller() { return !!Helper.getSeller() },
    dashboardActions() {
      const actions = [{ id: 'query', reference: 'query', route: 'BCRAStaffQuery', tone: 'primary' }]
      if(!this.isSeller) {
        actions.unshift({ id: 'configuration', reference: 'configuration', route: 'BCRAStaffConfiguration', tone: 'secondary' })
        actions.push({ id: 'logs', reference: 'logs', route: 'BCRAStaffLog', tone: 'warning' })
      }
      return actions
    },
  },
}
</script>
